import React, { useEffect } from 'react';

const ClientDetailModal = ({ client, onClose }) => {
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEsc);
    return () => document.removeEventListener('keydown', handleEsc);
  }, [onClose]);

  if (!client) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      onClick={handleBackdropClick}
    >
      <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md relative">
        <h3 className="text-xl font-bold mb-4 text-blue-700">Client Details</h3>
        <p><span className="font-semibold">Name:</span> {client.name}</p>
        <p><span className="font-semibold">Email:</span> {client.email}</p>
        <p><span className="font-semibold">Company:</span> {client.company}</p>
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-sm px-3 py-1 bg-gray-200 hover:bg-gray-300 rounded"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default ClientDetailModal;